import React from "react";
import { ValueOrPlaceholder } from "@sscs/ui";
import { GRADE_TO_PRIORITY } from "@sscs/utils";
import RenderChildrenWrapper from "../RenderChildrenWrapper";
import styles from "./priorityAndIssues.module.scss";
const SecurityGrade = ({ issueCount, grade, componentId, componentPath, severity, badgeWrapper, }) => {
    if (!grade || !severity || issueCount === 0) {
        return (React.createElement("div", { className: styles["no-issues"] },
            React.createElement(ValueOrPlaceholder, { value: undefined })));
    }
    // Submitted package (root file) has falsy path - ""
    const isLink = componentId !== null && componentPath !== null;
    const gradeComponent = (React.createElement("span", { className: isLink ? styles["priority-link"] : styles.priority },
        React.createElement("b", null, GRADE_TO_PRIORITY[grade]),
        React.createElement("span", { "aria-hidden": true }, "\u00B7"),
        issueCount.toLocaleString()));
    if (!isLink) {
        return React.createElement("div", null, gradeComponent);
    }
    return (React.createElement(RenderChildrenWrapper, { wrapper: badgeWrapper }, gradeComponent));
};
export default SecurityGrade;
//# sourceMappingURL=SecurityGrade.js.map